import styled from "styled-components";

import { Contract } from "../../types";
import { Typography } from "../atoms/Typography";
import { PdtIcon } from "../atoms/PdtIcon";
import { Tooltip } from "../atoms/Tooltip";
import {
  DataTable,
  DataListSimpleHeader,
  DataListBody,
  DataListRow,
  DataListBodyItem,
} from "../atoms/Table";
import { Button } from "../atoms/Button";

/**
 * ContractResponsiblePersonList Component
 */
type ContractResponsiblePersonListProps = {
  contracts: Contract[];
  onManagerClick: (contractId: string) => void;
};

const flexRatio = [0.3, 0.3, 1, 1, 2.2, 1, 1];

const headerTitles = [
  "",
  "製品",
  "名前",
  "部署",
  "メールアドレス",
  "Welcomeメール送信日",
  "",
];

const InitialBadge = styled.span`
  display: inline-block;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.positive};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const ButtonWrapper = styled.div`
  width: 170px;
  height: 30px;
  margin-left: auto;
`;

const WarningText = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

function InitialLabel() {
  return (
    <Typography size={1} bold as="span">
      <InitialBadge>初回</InitialBadge>
    </Typography>
  );
}

export function ContractResponsiblePersonList({
  contracts,
  onManagerClick,
}: ContractResponsiblePersonListProps) {
  const items = contracts.map((contract: Contract) => {
    const { responsiblePerson } = contract;
    const { emailContact } = responsiblePerson ?? {};
    return (
      <DataListRow flexRatio={flexRatio} key={contract.id}>
        <DataListBodyItem>
          {contract.initial && <InitialLabel />}
        </DataListBodyItem>
        <DataListBodyItem>
          <PdtIcon
            size={40}
            src={contract.pdt.iconPath}
            alt={contract.pdt.name}
          />
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={emailContact?.name ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {emailContact?.name}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={emailContact?.department ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {emailContact?.department}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={emailContact?.emailAddress ?? undefined}>
            <Typography size={2} withEllipsis={true}>
              {emailContact?.emailAddress}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          <Tooltip content={responsiblePerson?.welcomeMailSentAt?.toString()}>
            <Typography size={2}>
              {responsiblePerson?.welcomeMailSentAt?.toString()}
            </Typography>
          </Tooltip>
        </DataListBodyItem>
        <DataListBodyItem>
          {contract.responsiblePerson && (
            <ButtonWrapper>
              <Button
                buttonType="primary"
                onClick={() => onManagerClick(contract.id)}
              >
                ウェルカムメールの再送
              </Button>
            </ButtonWrapper>
          )}
        </DataListBodyItem>
      </DataListRow>
    );
  });

  return (
    <>
      <WarningText>
        <Typography bold size={1}>
          この製品管理責任者はメンバーに紐づいていない新しい仕様です。
          <br />
          完全に移行が完了するまでは、製品管理責任者のWelcomeメールの再送は使用しないでください。
        </Typography>
      </WarningText>
      <DataTable>
        <DataListSimpleHeader titles={headerTitles} flexRatio={flexRatio} />
        <DataListBody rows={items} />
      </DataTable>
    </>
  );
}
